import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconConvert(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M3 15C3.55228 15 4 15.4477 4 16V17C4 18.6569 5.34315 20 7 20H8C8.55228 20 9 20.4477 9 21C9 21.5523 8.55228 22 8 22H7C4.23858 22 2 19.7614 2 17V16C2 15.4477 2.44772 15 3 15Z"
        fill="currentColor"
      />
      <path
        d="M13.168 12.4453C13.4743 11.9858 14.0952 11.8616 14.5547 12.168C15.0142 12.4743 15.1384 13.0952 14.832 13.5547L13.8682 15H21C21.5523 15 22 15.4477 22 16C22 16.5523 21.5523 17 21 17H13.8682L14.832 18.4453C15.1384 18.9048 15.0142 19.5257 14.5547 19.832C14.0952 20.1384 13.4743 20.0142 13.168 19.5547L10.7979 16L13.168 12.4453Z"
        fill="currentColor"
      />
      <path
        d="M9.44531 4.16797C9.90484 3.86162 10.5257 3.98578 10.832 4.44531L13.2021 8L10.832 11.5547C10.5257 12.0142 9.90483 12.1384 9.44531 11.832C8.98579 11.5257 8.86164 10.9048 9.16797 10.4453L10.1318 9H3C2.44773 9 2.00003 8.55226 2 8C2 7.44771 2.44772 7 3 7H10.1318L9.16797 5.55469C8.86162 5.09517 8.9858 4.47433 9.44531 4.16797Z"
        fill="currentColor"
      />
      <path
        d="M17 2C19.7614 2 22 4.23858 22 7V8C22 8.55228 21.5523 9 21 9C20.4477 9 20 8.55228 20 8V7C20 5.34315 18.6569 4 17 4H16C15.4477 4 15 3.55228 15 3C15 2.44772 15.4477 2 16 2H17Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
